import React from 'react';
import './InstructionsPanel.css';

interface InstructionsPanelProps {
  onStart: () => void;
  onFinishAttempt: () => void;
  onRepeat: () => void;
  onStartRecording?: () => void;
  onPrevious?: () => void;
  showPrevious?: boolean;
  canGoPrevious?: boolean;
  isRecording?: boolean;
  showStartRecording?: boolean;
  disabled?: boolean;
}

const InstructionsPanel: React.FC<InstructionsPanelProps> = ({
  onStart,
  onFinishAttempt,
  onRepeat,
  onStartRecording,
  onPrevious,
  showPrevious = false,
  canGoPrevious = false,
  isRecording,
  showStartRecording = false,
  disabled = false
}) => {
  return (
    <div className="instructions-panel">
      <div className="instruction-section">
        <h3 className="instruction-title">To hear the segment</h3>
        <div className="instruction-item">
          <span className="bullet">•</span>
          <span className="instruction-text">Click</span>
          <button className="action-btn start-btn" onClick={onStart} disabled={disabled}>
            Play
          </button>
          <span className="instruction-text">or</span>
          <button className="action-btn repeat-btn" onClick={onRepeat} disabled={disabled}>
            Repeat
          </button>
          {showStartRecording && onStartRecording && (
            <>
              <span className="instruction-text">or</span>
              <button 
                className="action-btn start-btn" 
                onClick={onStartRecording}
                disabled={disabled}
              >
                Start Recording
              </button>
            </>
          )}
          <span className="instruction-text">and speak after the chime</span>
        </div>
      </div>

      <div className="instruction-section">
        <h3 className="instruction-title">Next</h3>
        <div className="instruction-item">
          <span className="bullet">•</span>
          <span className="instruction-text">Click</span>
          <button 
            className="action-btn finish-btn" 
            onClick={onFinishAttempt}
            disabled={disabled || !isRecording}
          >
            Next
          </button>
          {showPrevious && (
            <>
              <span className="instruction-text">or</span>
              <button
                className="action-btn repeat-btn"
                onClick={onPrevious}
                disabled={disabled || !canGoPrevious}
              >
                Previous
              </button>
            </>
          )}
          <span className="instruction-text">to upload</span>
        </div>
      </div>

      <div className="instruction-section">
        <h3 className="instruction-title">To repeat a segment</h3>
        <p className="instruction-note">(One per dialogue without penalty)</p>
        <div className="instruction-item">
          <span className="bullet">•</span>
          <span className="instruction-text">Click</span>
          <button className="action-btn repeat-btn" onClick={onRepeat} disabled={disabled}>
            Repeat
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstructionsPanel;

